var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[(_vm.$route.name == 'rolesCreate')?_c('addHeader',{attrs:{"title":_vm.$t('roles.form.createRole'),"description":_vm.$t('roles.form.fromHereYouCanCreateANewUserRole')}}):_vm._e(),(_vm.$route.name == 'rolesEdit')?_c('addHeader',{attrs:{"title":_vm.$t('roles.form.editRole'),"description":_vm.$t('roles.form.fromHereYouCanModifyTheUsersRoles')}}):_vm._e(),_c('div',{staticClass:"mb-4 row"},[_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_c('dvider',{staticClass:"dic-role",attrs:{"title":_vm.$t('roles.form.basicInformation'),"noLine":"true"}})],1),_c('hr'),_c('div',{staticClass:"card-body"},[_c('formInput',{attrs:{"title":_vm.$t('roles.form.roleName'),"col":'col-12',"hasErorr":_vm.errors.name,"error":_vm.$t('allerts.thisFieldIsRequired'),"maxlength":"255"},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}}),_c('formTextarea',{attrs:{"title":_vm.$t('roles.form.descriptionOfRole')},model:{value:(_vm.item.discription),callback:function ($$v) {_vm.$set(_vm.item, "discription", $$v)},expression:"item.discription"}})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(" "+_vm._s(_vm.$t('roles.form.options'))+" ")]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.Companies'),"icon":'city',"values":[
                { name: _vm.$t('roles.form.view'), key: 'companies_show' },
                { name: _vm.$t('roles.form.add'), key: 'companies_add' },
                { name: _vm.$t('roles.form.edit'), key: 'companies_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'companies_delete' }
              ]}}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.users'),"icon":'user-chart',"values":[
                { name: _vm.$t('roles.form.view'), key: 'users_show' },
                { name: _vm.$t('roles.form.add'), key: 'users_add' },
                { name: _vm.$t('roles.form.edit'), key: 'users_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'users_delete' }
              ]}}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.roles'),"icon":'users-class',"values":[
                { name: _vm.$t('roles.form.view'), key: 'roles_show' },
                { name: _vm.$t('roles.form.add'), key: 'roles_add' },
                { name: _vm.$t('roles.form.edit'), key: 'roles_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'roles_delete' }
              ]}})],1)]),_c('hr'),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v("المبيعات")]),_c('hr'),_c('div',{staticClass:"card-body"},[(_vm.$site.customers_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.customers'),"icon":'user-alt',"values":[
                { name: _vm.$t('roles.form.view'), key: 'customers_show' },
                { name: _vm.$t('roles.form.add'), key: 'customers_add' },
                { name: _vm.$t('roles.form.edit'), key: 'customers_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'customers_delete' }
              ]}}):_vm._e(),_c('hr'),(_vm.$site.quotations_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.estimates'),"icon":'calculator',"values":[
                { name: _vm.$t('roles.form.view'), key: 'quotations_show' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'quotations_show_allow'
                },
                { name: _vm.$t('roles.form.add'), key: 'quotations_add' },
                {
                  name: _vm.$t('roles.form.changeProduct'),
                  key: 'quotations_edit_product_show'
                },
                { name: _vm.$t('roles.form.edit'), key: 'quotations_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'quotations_delete' },
                {
                  name: _vm.$t('roles.form.TransferToInvoice'),
                  key: 'quotations_turn_into_invoice_show'
                }
              ]}}):_vm._e(),(_vm.$site.quotations_allow)?_c('hr',{staticClass:"col-12"}):_vm._e(),(_vm.$site.quotations_allow)?_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('roles.form.AvailableCases')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":[
                    { name: _vm.$t('invoices.draft'), id: 0 },
                    { name: _vm.$t('invoices.approved'), id: 1 }
                  ],"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('roles.form.CasesAvailableForOrder'),"label":"name","track-by":"id","hide-selected":true},model:{value:(_vm.item.quotations_allow_status),callback:function ($$v) {_vm.$set(_vm.item, "quotations_allow_status", $$v)},expression:"item.quotations_allow_status"}})],1)]):_vm._e(),(_vm.$site.quotations_allow)?_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('roles.form.TheCasesShown')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":[
                    { name: _vm.$t('invoices.draft'), id: 0 },
                    { name: _vm.$t('invoices.approved'), id: 1 }
                  ],"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('roles.form.CasesPresentedToOrder'),"label":"name","track-by":"id","hide-selected":true},model:{value:(_vm.item.quotations_show_status),callback:function ($$v) {_vm.$set(_vm.item, "quotations_show_status", $$v)},expression:"item.quotations_show_status"}})],1)]):_vm._e(),(_vm.$site.quotations_allow)?_c('hr',{staticClass:"col-12"}):_vm._e(),(_vm.$site.invoices_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.invoices'),"icon":'file-invoice-dollar',"values":[
                { name: _vm.$t('roles.form.view'), key: 'invoices_show' },
                { name: _vm.$t('roles.form.add'), key: 'invoices_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'invoices_show_allow'
                },
                { name: _vm.$t('roles.form.edit'), key: 'invoices_edit' },
                {
                  name: _vm.$t('roles.form.changeProduct'),
                  key: 'invoices_edit_product'
                },
                { name: _vm.$t('roles.form.delete'), key: 'invoices_delete' },
                {
                  name: _vm.$t('roles.form.shortSale'),
                  key: 'invoices_short_sale'
                }
              ]}}):_vm._e(),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.SaleReturns'),"icon":'exchange',"values":[
                { name: _vm.$t('roles.form.view'), key: 'sale_returns_show' },
                { name: _vm.$t('roles.form.add'), key: 'sale_returns_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'sale_returns_show_allow'
                },
                { name: _vm.$t('roles.form.edit'), key: 'sale_returns_edit' },
                {
                  name: _vm.$t('roles.form.changeProduct'),
                  key: 'sale_returns_edit_product'
                },
                { name: _vm.$t('roles.form.delete'), key: 'sale_returns_delete' },
                {
                  name: _vm.$t('roles.form.shortSale'),
                  key: 'sale_returns_short_sale'
                }
              ]}}),(_vm.$site.quotations_allow)?_c('hr',{staticClass:"col-12"}):_vm._e(),(_vm.$site.orders_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.saleOrders'),"icon":'briefcase',"values":[
                { name: _vm.$t('roles.form.view'), key: 'orders_show' },
                { name: _vm.$t('roles.form.add'), key: 'orders_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'orders_show_allow'
                },
                { name: _vm.$t('roles.form.editDate'), key: 'orders_edit_date' },
                {
                  name: _vm.$t('roles.form.changeProduct'),
                  key: 'orders_edit_product'
                },
                { name: _vm.$t('roles.form.edit'), key: 'orders_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'orders_delete' },
                {
                  name: _vm.$t('roles.form.TransferToInvoice'),
                  key: 'orders_delete'
                }
              ]}}):_vm._e(),_c('hr',{staticClass:"col-12"})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v("المشتريات")]),_c('hr'),_c('div',{staticClass:"card-body"},[(_vm.$site.suppliers_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.suppliers'),"icon":'user-tie',"values":[
                { name: _vm.$t('roles.form.view'), key: 'suppliers_show' },
                { name: _vm.$t('roles.form.add'), key: 'suppliers_add' },
                { name: _vm.$t('roles.form.edit'), key: 'suppliers_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'suppliers_delete' }
              ]}}):_vm._e(),_c('hr',{staticClass:"col-12"}),(_vm.$site.bills_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('فواتير الشراء'),"icon":'receipt',"values":[
                { name: _vm.$t('roles.form.view'), key: 'bills_show' },
                { name: _vm.$t('roles.form.add'), key: 'bills_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'bills_show_allow'
                },
                {
                  name: _vm.$t('roles.form.changeProduct'),
                  key: 'bills_edit_product'
                },
                { name: _vm.$t('roles.form.edit'), key: 'bills_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'bills_delete'
                }
              ]}}):_vm._e(),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.PurchaseReturns'),"icon":'exchange',"values":[
                { name: _vm.$t('roles.form.view'), key: 'purchase_returns_show' },
                { name: _vm.$t('roles.form.add'), key: 'purchase_returns_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'purchase_returns_show_allow'
                },
                { name: _vm.$t('roles.form.edit'), key: 'purchase_returns_edit' },
                {
                  name: _vm.$t('roles.form.changeProduct'),
                  key: 'purchase_returns_edit_product'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'purchase_returns_delete'
                },
                {
                  name: _vm.$t('roles.form.shortSale'),
                  key: 'purchase_returns_short_sale'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.purchaseOrders'),"icon":'briefcase',"values":[
                { name: _vm.$t('roles.form.view'), key: 'purchase_orders_show' },
                { name: _vm.$t('roles.form.add'), key: 'purchase_orders_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'purchase_orders_show_allow'
                },
                {
                  name: _vm.$t('roles.form.changeProduct'),
                  key: 'purchase_orders_edit_product'
                },
                { name: _vm.$t('roles.form.edit'), key: 'purchase_orders_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'purchase_orders_delete'
                }
              ]}})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v("الخزائن")]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.safes'),"icon":'treasure-chest',"values":[
                { name: _vm.$t('roles.form.view'), key: 'safes_show' },
                { name: _vm.$t('roles.form.add'), key: 'safes_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'safes_show_allow'
                },
                { name: _vm.$t('roles.form.edit'), key: 'safes_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'safes_delete' }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.bankAccounts'),"icon":'university',"values":[
                { name: _vm.$t('roles.form.view'), key: 'bank_accounts_show' },
                { name: _vm.$t('roles.form.add'), key: 'bank_accounts_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'bank_accounts_show_allow'
                },
                { name: _vm.$t('roles.form.edit'), key: 'bank_accounts_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'bank_accounts_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.salePayments'),"icon":'credit-card-front',"values":[
                { name: _vm.$t('roles.form.view'), key: 'sales_payments_show' },
                { name: _vm.$t('roles.form.add'), key: 'sales_payments_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'sales_payments_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'sales_payments_edit_item'
                },
                { name: _vm.$t('roles.form.edit'), key: 'sales_payments_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'sales_payments_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.purchasePayments'),"icon":'credit-card-front',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'purchase_payments_show'
                },
                { name: _vm.$t('roles.form.add'), key: 'purchase_payments_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'purchase_payments_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'purchase_payments_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'purchase_payments_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'purchase_payments_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.expenses'),"icon":'usd-square',"values":[
                { name: _vm.$t('roles.form.view'), key: 'expenses_show' },
                { name: _vm.$t('roles.form.add'), key: 'expenses_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'expenses_show_allow'
                },
                { name: _vm.$t('roles.form.edit'), key: 'expenses_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'expenses_delete' }
              ]}}),_c('hr',{staticClass:"col-12"}),(_vm.$site.safes_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.safes'),"icon":'treasure-chest',"values":[
                { name: _vm.$t('roles.form.view'), key: 'safes_show' },
                { name: _vm.$t('roles.form.add'), key: 'safes_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'safes_show_allow'
                },
                { name: _vm.$t('roles.form.edit'), key: 'safes_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'safes_delete' }
              ]}}):_vm._e(),(_vm.$site.safes_allow)?_c('hr',{staticClass:"col-12"}):_vm._e(),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.depositLockers'),"icon":'envelope-open-dollar',"values":[
                { name: _vm.$t('roles.form.view'), key: 'safes_deposits_show' },
                { name: _vm.$t('roles.form.add'), key: 'safes_deposits_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'safes_deposits_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'safes_deposits_edit_item'
                },
                { name: _vm.$t('roles.form.edit'), key: 'safes_deposits_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'safes_deposits_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.pullOutLockers'),"icon":'envelope-open-dollar',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'safes_withdrawals_show'
                },
                { name: _vm.$t('roles.form.add'), key: 'safes_withdrawals_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'safes_withdrawals_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'safes_withdrawals_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'safes_withdrawals_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'safes_withdrawals_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.MovingLockers'),"icon":'envelope-open-dollar',"values":[
                { name: _vm.$t('roles.form.view'), key: 'safes_transfers_show' },
                { name: _vm.$t('roles.form.add'), key: 'safes_transfers_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'safes_transfers_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'safes_transfers_edit_item'
                },
                { name: _vm.$t('roles.form.edit'), key: 'safes_transfers_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'safes_transfers_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v("المخازن")]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.stores'),"icon":'store-alt',"values":[
                { name: _vm.$t('roles.form.view'), key: 'stores_show' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'stores_show_allow'
                },
                { name: _vm.$t('roles.form.add'), key: 'stores_add' },
                { name: _vm.$t('roles.form.edit'), key: 'stores_edit' },
                {
                  name: _vm.$t('roles.form.ProductsTransportation'),
                  key: 'stores_move_products'
                },
                {
                  name: _vm.$t('roles.form.addProducts'),
                  key: 'stores_add_products'
                },
                {
                  name: _vm.$t('roles.form.withdrawProducts'),
                  key: 'stores_remove_products'
                },
                { name: _vm.$t('roles.form.delete'), key: 'stores_delete' }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.products'),"icon":'inventory',"values":[
                { name: _vm.$t('roles.form.view'), key: 'products_show' },
                { name: _vm.$t('roles.form.add'), key: 'products_add' },
                { name: _vm.$t('roles.form.edit'), key: 'products_edit' },
                { name: _vm.$t('roles.form.cost'), key: 'products_cost' },
                { name: _vm.$t('roles.form.delete'), key: 'products_delete' }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.warehouseDeposit'),"icon":'boxes-alt',"values":[
                { name: _vm.$t('roles.form.view'), key: 'stores_deposits_show' },
                { name: _vm.$t('roles.form.add'), key: 'stores_deposits_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'stores_deposits_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'stores_deposits_edit_item'
                },
                { name: _vm.$t('roles.form.edit'), key: 'stores_deposits_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'stores_deposits_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.storeWithdrawals'),"icon":'boxes-alt',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'stores_withdrawals_show'
                },
                { name: _vm.$t('roles.form.add'), key: 'stores_withdrawals_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'stores_withdrawals_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'stores_withdrawals_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'stores_withdrawals_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'stores_withdrawals_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.warehouseTransfer'),"icon":'boxes-alt',"values":[
                { name: _vm.$t('roles.form.view'), key: 'stores_transfers_show' },
                { name: _vm.$t('roles.form.add'), key: 'stores_transfers_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'stores_transfers_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'stores_transfers_edit_item'
                },
                { name: _vm.$t('roles.form.edit'), key: 'stores_transfers_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'stores_transfers_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":"تحميل المخازن","icon":'boxes-alt',"values":[
                { name: _vm.$t('roles.form.view'), key: 'stores_orders_show' },
                { name: _vm.$t('roles.form.add'), key: 'stores_orders_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'stores_orders_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'stores_orders_edit_item'
                },
                { name: _vm.$t('roles.form.edit'), key: 'stores_orders_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'stores_orders_delete'
                }
              ]}})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v("الموظفين")]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.employees'),"icon":'user-cog',"values":[
                { name: _vm.$t('roles.form.view'), key: 'employees_show' },
                { name: _vm.$t('roles.form.add'), key: 'employees_add' },
                { name: _vm.$t('roles.form.edit'), key: 'employees_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'employees_delete' }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.employeeSalaries'),"icon":'user-chart',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'employees_salaries_show'
                },
                { name: _vm.$t('roles.form.add'), key: 'employees_salaries_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'employees_salaries_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'employees_salaries_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'employees_salaries_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'employees_salaries_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.employeeIncentives'),"icon":'user-chart',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'employees_incentives_show'
                },
                {
                  name: _vm.$t('roles.form.add'),
                  key: 'employees_incentives_add'
                },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'employees_incentives_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'employees_incentives_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'employees_incentives_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'employees_incentives_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.employeeDiscounts'),"icon":'user-chart',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'employees_deductions_show'
                },
                {
                  name: _vm.$t('roles.form.add'),
                  key: 'employees_deductions_add'
                },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'employees_deductions_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'employees_deductions_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'employees_deductions_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'employees_deductions_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.staffDraws'),"icon":'user-chart',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'employees_withdrawals_show'
                },
                {
                  name: _vm.$t('roles.form.add'),
                  key: 'employees_withdrawals_add'
                },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'employees_withdrawals_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'employees_withdrawals_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'employees_withdrawals_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'employees_withdrawals_delete'
                }
              ]}})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v("الشركاء")]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.partners'),"icon":'handshake',"values":[
                { name: _vm.$t('roles.form.view'), key: 'partners_show' },
                { name: _vm.$t('roles.form.add'), key: 'partners_add' },
                { name: _vm.$t('roles.form.edit'), key: 'partners_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'partners_delete' }
              ]}}),(_vm.$site.partners_allow)?_c('hr',{staticClass:"col-12"}):_vm._e(),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.partnersDeposit'),"icon":'handshake',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'partners_deposits_show'
                },
                { name: _vm.$t('roles.form.add'), key: 'partners_deposits_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'partners_deposits_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'partners_deposits_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'partners_deposits_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'partners_deposits_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.WithdrawalOfPartners'),"icon":'handshake',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'partners_withdrawals_show'
                },
                {
                  name: _vm.$t('roles.form.add'),
                  key: 'partners_withdrawals_add'
                },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'partners_withdrawals_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'partners_withdrawals_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'partners_withdrawals_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'partners_withdrawals_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.partnersProfits'),"icon":'handshake',"values":[
                { name: _vm.$t('roles.form.view'), key: 'partners_profits_show' },
                { name: _vm.$t('roles.form.add'), key: 'partners_profits_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'partners_profits_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'partners_profits_edit_item'
                },
                { name: _vm.$t('roles.form.edit'), key: 'partners_profits_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'partners_profits_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.partnersSettlements'),"icon":'handshake',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'partners_settlements_show'
                },
                {
                  name: _vm.$t('roles.form.add'),
                  key: 'partners_settlements_add'
                },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'partners_settlements_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'partners_settlements_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'partners_settlements_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'partners_settlements_delete'
                }
              ]}})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v("الشيكات")]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.salesCheques'),"icon":'money-check-alt',"values":[
                { name: _vm.$t('roles.form.view'), key: 'sales_cheques_show' },
                { name: _vm.$t('roles.form.add'), key: 'sales_cheques_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'sales_cheques_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: '.sales_cheques_edit_item'
                },
                { name: _vm.$t('roles.form.edit'), key: 'sales_cheques_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'sales_cheques_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.purchaseCheques'),"icon":'money-check-alt',"values":[
                { name: _vm.$t('roles.form.view'), key: 'purchase_cheques_show' },
                { name: _vm.$t('roles.form.add'), key: 'purchase_cheques_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'purchase_cheques_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'purchase_cheques_edit_item'
                },
                { name: _vm.$t('roles.form.edit'), key: 'purchase_cheques_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'purchase_cheques_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v("الخصومات")]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.salesDiscounts'),"icon":'badge-percent',"values":[
                { name: _vm.$t('roles.form.view'), key: 'sales_discounts_show' },
                { name: _vm.$t('roles.form.add'), key: 'sales_discounts_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'sales_discounts_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'sales_discounts_edit_item'
                },
                { name: _vm.$t('roles.form.edit'), key: 'sales_discounts_edit' },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'sales_discounts_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.purchaseDiscounts'),"icon":'badge-percent',"values":[
                {
                  name: _vm.$t('roles.form.view'),
                  key: 'purchase_discounts_show'
                },
                { name: _vm.$t('roles.form.add'), key: 'purchase_discounts_add' },
                {
                  name: _vm.$t('roles.form.SelectedWidth'),
                  key: 'purchase_discounts_show_allow'
                },
                {
                  name: _vm.$t('roles.form.ChangeOptions'),
                  key: 'purchase_discounts_edit_item'
                },
                {
                  name: _vm.$t('roles.form.edit'),
                  key: 'purchase_discounts_edit'
                },
                {
                  name: _vm.$t('roles.form.delete'),
                  key: 'purchase_discounts_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v("عمليات")]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('roles.form.capitals'),"icon":'archway',"values":[
                { name: _vm.$t('roles.form.view'), key: 'capitals_show' },
                { name: _vm.$t('roles.form.add'), key: 'capitals_add' },
                { name: _vm.$t('roles.form.edit'), key: 'capitals_edit' },
                { name: _vm.$t('roles.form.delete'), key: 'capitals_delete' }
              ]}}),_c('hr',{staticClass:"col-12"})],1)]),_c('hr',{staticClass:"mt-5 mb-5 col-12"}),_c('small',{staticClass:"form-text text-muted mb-4 col-12"},[_vm._v(_vm._s(_vm.$t('roles.form.iNFORMATION')))]),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"reports_show"}},[_c('i',{staticClass:"far fa-user-chart"}),_vm._v(" "+_vm._s(_vm.$t('roles.form.reports'))+" : ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.reports_show),expression:"item.reports_show"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"reports_show","value":"1"},domProps:{"checked":Array.isArray(_vm.item.reports_show)?_vm._i(_vm.item.reports_show,"1")>-1:(_vm.item.reports_show)},on:{"change":function($event){var $$a=_vm.item.reports_show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "reports_show", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "reports_show", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "reports_show", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"reports_show"}})])])]),(_vm.item.reports_show)?_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"reports_show"}},[_c('i',{staticClass:"far fa-user-chart"}),_vm._v(" "+_vm._s(_vm.$t('roles.form.ShowSelectedReports'))+" : ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.reports_show_allow),expression:"item.reports_show_allow"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"reports_show_allow","value":"1"},domProps:{"checked":Array.isArray(_vm.item.reports_show_allow)?_vm._i(_vm.item.reports_show_allow,"1")>-1:(_vm.item.reports_show_allow)},on:{"change":function($event){var $$a=_vm.item.reports_show_allow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "reports_show_allow", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "reports_show_allow", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "reports_show_allow", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"reports_show_allow"}})])])]):_vm._e(),(_vm.item.reports_show)?_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"reports_earning_show"}},[_c('i',{staticClass:"far fa-user-chart"}),_vm._v(" "+_vm._s(_vm.$t('roles.form.ViewEarningsInReports'))+" : ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.reports_earning_show),expression:"item.reports_earning_show"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"reports_earning_show","value":"1"},domProps:{"checked":Array.isArray(_vm.item.reports_earning_show)?_vm._i(_vm.item.reports_earning_show,"1")>-1:(_vm.item.reports_earning_show)},on:{"change":function($event){var $$a=_vm.item.reports_earning_show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "reports_earning_show", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "reports_earning_show", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "reports_earning_show", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"reports_earning_show"}})])])]):_vm._e(),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"accounting_show"}},[_c('i',{staticClass:"far fa-balance-scale"}),_vm._v(" "+_vm._s(_vm.$t('roles.form.Accounting'))+" : ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.accounting_show),expression:"item.accounting_show"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"accounting_show","value":"1"},domProps:{"checked":Array.isArray(_vm.item.accounting_show)?_vm._i(_vm.item.accounting_show,"1")>-1:(_vm.item.accounting_show)},on:{"change":function($event){var $$a=_vm.item.accounting_show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "accounting_show", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "accounting_show", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "accounting_show", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"accounting_show"}})])])]),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"options_show"}},[_c('i',{staticClass:"far fa-cog"}),_vm._v(" "+_vm._s(_vm.$t('roles.form.Settings'))+": ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.options_show),expression:"item.options_show"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"options_show","value":"1"},domProps:{"checked":Array.isArray(_vm.item.options_show)?_vm._i(_vm.item.options_show,"1")>-1:(_vm.item.options_show)},on:{"change":function($event){var $$a=_vm.item.options_show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "options_show", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "options_show", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "options_show", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"options_show"}})])])]),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"profile_edit"}},[_c('i',{staticClass:"far fa-cog"}),_vm._v(_vm._s(_vm.$t('roles.form.UserSettings'))+": ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.profile_edit),expression:"item.profile_edit"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"profile_edit","value":"1"},domProps:{"checked":Array.isArray(_vm.item.profile_edit)?_vm._i(_vm.item.profile_edit,"1")>-1:(_vm.item.profile_edit)},on:{"change":function($event){var $$a=_vm.item.profile_edit,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "profile_edit", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "profile_edit", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "profile_edit", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"profile_edit"}})])])]),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"buckup_allow"}},[_c('i',{staticClass:"far fa-database"}),_vm._v(" "+_vm._s(_vm.$t('roles.form.buckupAllow'))+" : ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.buckup_allow),expression:"item.buckup_allow"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"buckup_allow","value":"1"},domProps:{"checked":Array.isArray(_vm.item.buckup_allow)?_vm._i(_vm.item.buckup_allow,"1")>-1:(_vm.item.buckup_allow)},on:{"change":function($event){var $$a=_vm.item.buckup_allow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "buckup_allow", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "buckup_allow", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "buckup_allow", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"buckup_allow"}})])])]),(_vm.item.reports_show)?_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('roles.form.FrontReports')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":_vm.reports,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('roles.form.ChooseTheRequiredReportsInTheInterface'),"label":"name","track-by":"link","hide-selected":true},model:{value:(_vm.item.main_reports),callback:function ($$v) {_vm.$set(_vm.item, "main_reports", $$v)},expression:"item.main_reports"}})],1)]):_vm._e(),(_vm.item.reports_show)?_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('roles.form.AvailableReports')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":_vm.allowReports,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('roles.form.ChooseTheAvailableReports'),"label":"name","track-by":"id","hide-selected":true},model:{value:(_vm.item.available_reports),callback:function ($$v) {_vm.$set(_vm.item, "available_reports", $$v)},expression:"item.available_reports"}})],1)]):_vm._e(),_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('roles.form.ExhibitsInTheFacade')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":_vm.elements,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('roles.form.ChooseDisplaysInTheInterface'),"label":"name","track-by":"id","hide-selected":true},model:{value:(_vm.item.main_elements),callback:function ($$v) {_vm.$set(_vm.item, "main_elements", $$v)},expression:"item.main_elements"}})],1)]),_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('roles.form.mainActions')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":_vm.actions,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('roles.form.ChooseActionsInTheInterface'),"label":"name","track-by":"link","hide-selected":true},model:{value:(_vm.item.main_actions),callback:function ($$v) {_vm.$set(_vm.item, "main_actions", $$v)},expression:"item.main_actions"}})],1)]),_c('hr',{staticClass:"mt-5 mb-5 col-12"}),(_vm.$route.name == 'rolesCreate' && !_vm.$parent.stopEdit)?_c('a',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){return _vm.saveItem()}}},[_vm._v(" "+_vm._s(_vm.$t('roles.form.createRole'))+" ")]):_vm._e(),(_vm.$route.name == 'rolesEdit' && !_vm.$parent.stopEdit)?_c('a',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){return _vm.saveItem()}}},[_vm._v(" "+_vm._s(_vm.$t('roles.form.editRole'))+" ")]):_vm._e(),(_vm.$parent.stopEdit)?_c('loading'):_vm._e()],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }